// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'send';

export const Component = () => (
  <path d='m1.5 2.5 22 10-22 10 2.849-9.954L1.5 2.5Zm1.495 1.706L5.177 12H16v1H5.201l-2.206 7.795L21.21 12.5 2.995 4.206Z' />
);

export const viewBox = '0 0 25 25';
